import headers from "app/requests/headers";

export const create = (params) => (
  fetch("/api/admin/newsletters", {
    body: JSON.stringify(params),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const destroy = (id) => (
  fetch(`/api/admin/newsletters/${id}`, {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const get = (id) => (
  fetch(`/api/admin/newsletters/${id}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const getAll = () => (
  fetch("/api/admin/newsletters", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const preview = (id) => (
  fetch(`/api/admin/newsletters/${id}/preview`, {
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const publish = (id, params) => (
  fetch(`/api/admin/newsletters/${id}/publish`, {
    body: JSON.stringify(params),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const unpublish = (id) => (
  fetch(`/api/admin/newsletters/${id}/publish`, {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const update = (id, params) => (
  fetch(`/api/admin/newsletters/${id}`, {
    body: JSON.stringify(params),
    headers: headers(),
    method: "PUT"
  }).then((response) => response.json())
);
